import gql from "graphql-tag";
import { ArticleBylineFragment, ArticleBylineAuthorFragment } from "types/api";
import styles from "./ArticleByline.module.scss";
import Authors from "components/Authors";

const AuthorWrapper = ({ url, displayName }: ArticleBylineAuthorFragment) => {
  return (
    <a
      className={styles.link}
      href={url}
      data-action="click author - byline"
      data-label={url}
    >
      {displayName}
    </a>
  );
};

const ArticleByline = ({ authors }: ArticleBylineFragment) => {
  return (
    <address className={styles.root} id="byline">
      <Authors authors={authors} component={AuthorWrapper} />
    </address>
  );
};

export default ArticleByline;

ArticleByline.fragment = gql`
  fragment articleBylineAuthor on Author {
    id
    url
    displayName
  }

  fragment articleByline on Article {
    authors {
      ...articleBylineAuthor
    }
  }
`;
